import { marked } from 'marked'
import { defineNuxtPlugin } from '#app'

marked.setOptions({
  // breaks: true,
  // gfm: true,
  // pedantic: true,
})

function replaceNewlinesInPTags(text: string) {
  // Replace matching \n with <br>\n, but only if not preceded by <br>
  return text.replace(/<p>([\s\S]*?)<\/p>/g, (_match, p1) => {
    const replacedContent = p1.replace(/(<br>)?\n/g, () => '<br>\n')
    return `<p>${replacedContent}</p>`
  })
}

function addLazyForImages(text: string) {
  return text.replace(/<img/g, '<img loading="lazy"')
}

export default defineNuxtPlugin((nuxtApp) => {
  nuxtApp.provide('marked', (text: string) => {
    return addLazyForImages(replaceNewlinesInPTags(marked(text)))
  })
})

declare module '#app' {
  interface NuxtApp {
    $marked: typeof marked
  }
}

declare module '@vue/runtime-core' {
  interface ComponentCustomProperties {
    $marked: typeof marked
  }
}
